<mat-nav-list class="flex flex-col">
    <a (click)="onClose()" mat-list-item>
        <mat-icon class="mr-2">menu</mat-icon>
        Close navigation
    </a>

    @if (links?.length && (auth.isAuthenticated$ | async)) {
        <section class="section-navigation flex flex-col">
            <hr/>

            @for (link of links; track link) {
                <a (click)="onClose()" [routerLink]="link.href" mat-list-item
                    routerLinkActive="active"
                >
                    <mat-icon class="mr-2">{{link.icon}}</mat-icon>
                    <span>{{link.name}}</span>
                </a>
            }
        </section>
   }

   @if (auth.isAuthenticated$ | async) {
        <section class="site-navigation">
            <hr/>

            @for (navlink of navLinks; track navlink.name) {
                <a (click)="onClose()" [routerLink]="navlink.href" mat-list-item
                    routerLinkActive="active"
                >
                    <mat-icon class="mr-2">{{navlink.icon}}</mat-icon>
                    <span>{{navlink.name}}</span>
            </a>
            }
        </section>
   }

    <hr/>

    @if ((auth.isAuthenticated$ | async) === false) {
        <app-auth-button ></app-auth-button>
        <button mat-button (click)="signUp(); onClose()" class="w-full">
            <span>Signup</span>
        </button>
    }
    @else {
        <mat-list-item>
            <button (click)="auth.logout(); onClose()" class="w-full">
                <div class="flex flex-row justify-start items-center">
                    <div>
                        <mat-icon class="mr-2 text-2xl">eject</mat-icon>
                    </div>
                    <span class="text-lg">Logout</span>
                </div>
            </button>
        </mat-list-item>
    }
</mat-nav-list>
